import { render } from "./GameGiveaways.vue?vue&type=template&id=57fdd42f"
import script from "./GameGiveaways.vue?vue&type=script&lang=js"
export * from "./GameGiveaways.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__